export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.server) return
  const displayStore = useFitmentDisplayStore()
  displayStore.setupFitment()
})
